export default __webpack_public_path__ + "static/media/AcornMallFastFood_30.36f77a25.png";